import React, { PureComponent } from "react";
import WarningIcon from "../svg/warning";
import RepeatIcon  from "../svg/repeat";
import classnames  from "classnames";
import "./error-message.css";

export default class ErrorMessage extends PureComponent {
    static get propTypes() {
        return {
            text: React.PropTypes.string.isRequired,
            retryButton: React.PropTypes.bool,
            retryButtonText: React.PropTypes.string,
            onRetryClick: React.PropTypes.func,
            fill: React.PropTypes.bool,
        };
    }


    static get defaultProps() {
        return {
            text: "произошла ошибка",
            retryButtonText: "повторить",
            retryButton: true,
            onRetryClick: () => {},
            fill: false,
        };
    }

    render() {
        const errorMessageClasses = [];
        errorMessageClasses.push("appointment-error-message");
        if (this.props.fill === true) {
            errorMessageClasses.push("appointment-error-message--fill");
        }

        return (
            <div className={classnames(errorMessageClasses)}>
                <div className="appointment-error-message__content">
                    <WarningIcon />

                    <div className="appointment-error-message__text">
                        {this.props.text}
                    </div>

                    {this.props.retryButton ? <button
                        className="appointment-error-message__button"
                        onClick={this.props.onRetryClick}
                        type="button">
                            <RepeatIcon color={"#CDDC39"} />
                            {this.props.retryButtonText}
                    </button> : null}

                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/error-message.js
 **/